<template>
    <tr>
        <td>
            {{ campaign.index + 1 }}
        </td>
        <td>
            <a :href="`/campaigns/${campaign.id}?model=drafts`" target="_blank">
                {{ campaign.title }}
            </a>
        </td>
        <td>
            {{ campaign.author_id }}
        </td>
        <td>
            {{ campaign.email }}
        </td>
        <td>
            {{ addedDate }}
        </td>
        <td class="py-3 action-td">
            <Loader v-if="loading"/>
            <button
                    @click="activate(campaign.id)"
                    v-else-if="!isActive && !loading"
                    class="lab"
                    :class="[!isActive? 'accept-button': 'active']">
                {{!isActive ? 'Activate' : ''}}
            </button>
        </td>
    </tr>
</template>

<script>
import moment from 'moment'
import {updateData} from "../../../firebaseCRUD";
import {toggleFeatured} from "../../FeaturedCampaigns/featured.service";
import { message } from 'ant-design-vue'
import { verifyCampaign } from '../../../firebase';
import { ref } from '@vue/composition-api';
import Loader from '../../../components/Icons/Loader'

export default {
    props: [
        'campaign'
    ],
    data: function () {
        return {
            isActive: false,
            loading: false
        }
    },
    components: {
        Loader
    },
    methods: {
        activate: function (campId) {
            this.loading = true
            verifyCampaign({id: campId})
                .then(()=> {
                    message.success('Campaign is activated')
                })
                .catch(e => {
                    console.log(e.message)
                    message.error('Already existing campaign')
                })
                .finally(() => {
                    this.loading = false
                })
        }
    },
    computed: {
        addedDate() {
            return moment.unix(this.campaign.created_at.seconds).format('DD/MM/YYYY')
        }
    },
}
</script>
<style lang="scss" scoped>
.active {
    color: #0ACF97;
    font-size: 11px;
}

.action-td svg {
    width: 40px;
    height: 40px;
}
</style>